import {Component, OnInit, SystemJsNgModuleLoader} from '@angular/core';
import {Router} from '@angular/router';
import {LeftMenu} from './LeftMenu';
import {DataStorageService} from '../data-storage.service';
import {Subscription} from 'rxjs/Subscription';
import {User} from '../auth/user';
import {TranslateService} from '@ngx-translate/core';
import {NGXLogger} from 'ngx-logger';
import {Principal} from "../auth/principal.service";

@Component({
  selector: 'app-leftmenu',
  templateUrl: './leftmenu.component.html',
  styleUrls: ['./leftmenu.component.css']
})
export class LeftmenuComponent implements OnInit {
  subscription: Subscription;
  user: User;
  lang: string;
  leftMenu: LeftMenu = new LeftMenu();
  sessionClear = false;
  ekpayId: any=null;



  constructor(private datastorage: DataStorageService,
              private router: Router,
              private logger: NGXLogger,
              private dataStorageService: DataStorageService,
              private loader: SystemJsNgModuleLoader,
              private readonly translate: TranslateService,
              private principle: Principal) {

  }

  ngOnInit() {

    this.principle.identity(false).then(data=> {
      this.ekpayId = data.ekpay_id;

    })
      .catch(err=>console.log(err))

    //this.logger.debug('>>>>.left');
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      //this.logger.debug('data lang is ' + this.router.url);
      this.lang = data;
      if (this.lang === '' || this.lang == null) {
        this.lang = localStorage.getItem('lang');
      }
      if (this.router.url === '/') {
        this.lang = 'en';
      }
      //this.logger.debug('data lang is left' + this.lang);
      this.translate.use(this.lang);
    });

  }

  leftToggleMenu(menu: keyof LeftMenu, hasChildren: boolean = false) {
    const state = this.leftMenu[menu];
    this.leftMenu.initAll();
    if (hasChildren) {
      this.leftMenu[menu] = !state;
    } else {
      this.leftMenu[menu] = true;
    }
  }

  addBillers() {
    //console.log('add biller called..');
    this.datastorage.setekpayid('');
    this.sessionClear = true;
    sessionStorage.removeItem('biller_id');
    sessionStorage.removeItem('sess_biller');
    sessionStorage.removeItem('sess_reg_address');
    sessionStorage.removeItem('sess_comm_address');
    sessionStorage.removeItem('sess_bank_detail');
    sessionStorage.removeItem('sess_config_req');
    sessionStorage.removeItem('sess_offline');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/leftmenu/leftmenu.component.ts